import { createAction, props } from '@ngrx/store';

import { DownloadFile } from '../../models';

export const downloadFile = createAction('[FILE] DOWNLOAD', props<{ payload: DownloadFile }>());
